<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">{{ bindingList.is_bind_app_for_easywallet ? '已綁定公國宅' : '綁定身分快速繳費(限社宅)' }}</span>
        </div>
        <div>
          <span v-show="bindingList.is_bind_app_for_easywallet" style="font-size: 16px" class="text-blue" @click="unbindHouse">解除綁定</span>
        </div>
      </div>
      <span
        v-show="!bindingList.is_bind_app_for_easywallet"
        style="font-family: PingFangTC-Medium; color: rgba(64, 64, 64, 0.6); font-family: PingFangTC-Medium; font-size: 14px"
      >
        免輸入身分證字號即可查詢待繳帳單，並收到繳費相關推播提醒！
      </span>
      <div class="dark-card" v-show="bindingList.is_bind_app_for_easywallet">
        <div class="flex border">
          <div>
            <div style="font-size: 16pt" class="text-gray1">{{ bindingList.housing_site_name }}</div>
            <div style="display: flex; flex-direction: row; margin-top: 4pt">
              <div style="font-size: 14px" class="text-gray2">{{ bindingList.date_of_start_rent }}</div>
              <span style="font-size: 14px" class="text-gray2">～</span>
              <div style="font-size: 14px" class="text-gray2">{{ bindingList.date_of_end_rent }}</div>
            </div>
          </div>
        </div>
      </div>

      <button
        class="text-nowrap btn btn-primary"
        style="margin-top: 16pt"
        @click="bindingList.is_bind_app_for_easywallet ? getPaymentInformation() : addBindingList()"
      >
        {{ bindingList.is_bind_app_for_easywallet ? '查詢待繳帳單' : '立即綁定' }}
      </button>
    </div>

    <div class="bg-white padding">
      <div class="input-item flex" style="justify-content: space-between">
        <div style="display: flex; align-items: center">
          <div class="line"></div>
          <span class="text-nowrap">{{ bindingList.is_bind_app_for_easywallet ? '查詢其他帳單' : '查詢帳單' }}</span>
          <!-- <span class="text-nowrap">查詢帳單</span> -->
        </div>
        <div class="icon-scan" @click="openScanner">掃描</div>
      </div>
      <div class="form">
        <div>
          <div class="field">
            <span class="required">*</span>
            國/社宅登記人身分證字號
          </div>
          <input
            type="text"
            name="id_card_number"
            placeholder="輸入身分證字號"
            class="input vinput"
            v-model="userId"
            @input="verifyId"
            @blur="verifyForm('userId')"
            :class="verify.userId.status ? '' : 'error'"
          />
          <div class="required">{{ verify.userId.text }}</div>
        </div>
      </div>
      <button class="btn btn-primary" :disabled="search_btn_disable" ref="search_btn" @click="getPaymentInformation(false)">查詢待繳帳單</button>
    </div>
    <div class="padding description">
      <ul class="text-gray2">
        <li>繳費規範限制請參閱紙本繳費單注意事項。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
      </ul>
    </div>

    <div v-show="dialog">
      <div class="dialog">
        <div class="img-box"><img src="../../assets/images/imgIdMagnifier@3x.png" /></div>
        <div class="dialog-text">
          即將把您的
          <span style="color: rgb(0, 122, 200)">身分證字號</span>
          <br />
          傳送至臺北市都發局查詢臺北市社宅住戶資料並綁定
        </div>
        <div class="agree-label" style="margin-bottom: 16pt">
          <input type="checkbox" id="isAddFavoriteChecked" v-model="isAddFavoriteChecked" @click.stop="isAddFavoriteChecked = !isAddFavoriteChecked" />
          <label for="isAddFavoriteChecked">
            我已經詳閱並同意
            <router-link :to="'/publicBuildingFee/HouseTermsOfPolicy'" class="text-blue">
              悠遊付會員為申請都發局綁定社宅住戶個資提供同意條款
            </router-link>
          </label>
        </div>
        <button class="btn btn-primary" @click="bindHouse" :disabled="agree_terms_checked">確定</button>
        <button class="btn btn-white" style="border: 0" @click="handleDialog">先不要</button>
      </div>
      <div class="dialog-mask"></div>
    </div>
  </div>
</template>
<script>
import { checkID } from '../../utils/verify-id';
import { queryBillList, queryHouseFeeBindingInformation, unbindHouse } from '../../api/api';
import { datetimeFormat } from '../../utils/format';
import { mapGetters } from 'vuex';

export default {
  name: 'public-building-fee',
  data() {
    return {
      userId: '',
      verify: {
        userId: {
          text: '',
          status: true,
        },
      },
      verifyInputRule: {
        userID: false,
      },
      bindingList: [],
      dialog: false,
      isAddFavoriteChecked: false,
    };
  },
  created() {
    window.getScanningResult = this.getScanningResult;
    this.getBoundList(true);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === '/publicBuildingFee/HouseTermsOfPolicy') {
        vm.dialog = true;
        vm.isAddFavoriteChecked = vm.isPublicBuildingFeeAgreementChecked;
      }
    });
  },
  computed: {
    ...mapGetters(['isPublicBuildingFeeAgreementChecked']),
    search_btn_disable() {
      return !this.verifyInputRule.userID;
    },
    agree_terms_checked() {
      return !this.isAddFavoriteChecked;
    },
  },
  methods: {
    getBoundList(isMounted) {
      queryHouseFeeBindingInformation().then((res) => {
        this.bindingList = res;
        this.bindingList.date_of_start_rent = datetimeFormat(res.date_of_start_rent);
        this.bindingList.date_of_end_rent = datetimeFormat(res.date_of_end_rent);

        if (isMounted === false) {
          if (!res.error) {
            if (!res.is_bind_app_for_easywallet) {
              sessionStorage.setItem('bindingHouseFee', JSON.stringify(this.bindingList));
              this.$router.push('/bindHouseFee');
            }
          } else {
            //alert('查無臺北市公國宅住戶資料');
            alert(res.error.message);
          }
        }
      });
    },
    addBindingList() {
      this.dialog = true;
    },
    bindHouse() {
      this.getBoundList(false);
    },
    unbindHouse() {
      if (confirm('確定要解除綁定嗎？\n解除後無法依身份快速查詢帳單')) {
        unbindHouse().then((res) => {
          if (!res.error) {
            this.getBoundList(true);
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    handleDialog() {
      this.dialog = !this.dialog;
      this.isAddFavoriteChecked = false;
    },
    verifyForm(fieldName) {
      if (this.userId !== '') {
        if (!this.verifyId(fieldName)) {
          this.verify[fieldName].status = false;
          this.verify[fieldName].text = '身分證填寫錯誤！';
        } else {
          this.verify[fieldName].status = true;
          this.verify[fieldName].text = '';
        }
      } else {
        this.verify[fieldName].status = true;
        this.verify[fieldName].text = '';
      }
    },
    verifyId() {
      this.userId = this.userId.toUpperCase();
      this.userId = this.userId.replace(/[\W]/g, '');
      if (this.userId.length >= 10 && checkID(this.userId)) {
        this.verifyInputRule.userID = true;
      } else {
        this.verifyInputRule.userID = false;
      }
      return this.verifyInputRule.userID;
    },
    openScanner() {
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 4, isAllowInput: true },
      });
    },
    getScanningResult(paymentCustomId) {
      if (paymentCustomId !== '') {
        this.getPaymentInformation(true, paymentCustomId);
      } else {
        if (this.$route.path !== '/publicBuildingBill') {
          this.$router.replace('/publicBuildingBill');
        }
      }
    },
    getPaymentInformation(isScanning, paymentCustomId) {
      var form = {
        payment_item_id: 21,
        payment_query_type: isScanning ? 2 : 1,
        parameter1: this.userId === '' ? this.bindingList.id_card_number : this.userId,
        //parameter1: this.userId,
        parameter2: '',
        parameter3: '',
        payment_custom_id: isScanning ? paymentCustomId : '',
      };
      queryBillList(form).then((res) => {
        if (res.error == null) {
          this.$router.push({
            path: '/goPay',
            query: form,
          });
        } else {
          alert(res.error.message);
        }
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.dialog {
  z-index: 99;
  background-color: #fff;
  padding: 24pt 20pt;
  border-radius: 16pt;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10%;

  .img-box {
    width: 100%;
    padding: 0 20pt 16pt 20pt;

    img {
      width: 100%;
    }
  }

  .dialog-text {
    text-align: center;
    font-size: 18px;
  }

  .agree-label {
    font-size: 14px;
    margin: 34pt 0 18pt 0;
    position: relative;

    label {
      text-align: left;
      display: inline-block;
      margin-left: 40px;
      vertical-align: center;
      align-items: center;
    }

    a:active {
      -webkit-tap-highlight-color: transparent;
    }
  }

  .agree-label label::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}

.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}

.dark-card {
  background-color: rgba(64, 64, 64, 0.05);
}
</style>
